import React, {ChangeEvent, FC } from "react";
import _ from "lodash";
import { HeaderModel } from "../../../../models/CommonModel";
import { formatPrice } from "../../../../selectors";
import { ImportRequestDetailModel, ImportRequestModel } from "../../../../models/ImportRequestModel";

type TProps = {
  importRequest?: ImportRequestModel,
  headers: HeaderModel[],
  hideCols: string[],
  handleChangeQty: (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => void,
  toggleCheck: (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => void,
  openColConfig: () => void,
  handleCheckAll?: (e: any) => void,
  editable: boolean
  selected: number[]
}

const ProductTable: FC<TProps> = ({
    importRequest,
    headers,
    hideCols,
    openColConfig,
    handleChangeQty,
    toggleCheck,
    editable,
    selected
  }) => {
  let details = importRequest?.details ?? []
  return <>
    <div className='table-responsive mt-5'>
      <table className={`table table-bordered border gy-7 gs-7`}>
        <thead>
        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
          {/* <th>
          </th> */}
          {headers.map((th, index) => {
            if (!hideCols.includes(th.field)) {
              return (
                <th key={'th-' + index} style={th?.style ?? {}}>{th.label}</th>
              )
            }
          })}
        </tr>
        </thead>
        <tbody>
        {details?.map((item: ImportRequestDetailModel, index: number) => {
          let checked = item.consign_product_id && selected.includes(item.consign_product_id);
          let product = item.product;
          let rowClass = item?.is_approved === 0 && (importRequest?.is_incorrect_quantity === 1 || importRequest?.is_incorrect_quality === 1) ? "cursor-pointer text-danger text-bold" : "cursor-pointer";
          return (
            <tr key={`order_product_${index}_${item.id}`} className={rowClass}>
              {/* <td>
                  <div className="form-check form-check-custom">
                    <input key={`item_checkbox_${item.id}_${!!checked}`} className="form-check-input" type="checkbox"
                        value={item.id}
                        disabled={!editable}
                        defaultChecked={!!checked}
                        name="checked"
                        onChange={(e) => toggleCheck(e, item)}/>
                  </div>
              </td> */}
              {!hideCols.includes('name') && (
                <td>
                  {product?.name ?? ''}
                </td>
              )}
              {!hideCols.includes('store') && (
                <td>
                  {importRequest?.store?.name ?? ''}
                </td>
              )}
              {!hideCols.includes('price') && (
                <td >
                    {formatPrice(product?.price ?? 0)}
                </td>
              )}
              {!hideCols.includes('request_quantity') && (
                <td className="">
                  { formatPrice(item?.request_quantity ?? 0)}
                </td>
              )}
              {!hideCols.includes('quantity') && (
                <td className="">
                  <div className="input-group input-group-sm mb-3 ">
                    <input className={"form-control form-control-sm" + (item?.quantity !== item?.request_quantity ? ' text-danger' : '')}  key={`receipt_quantity_${item.id}`}
                          min={0} 
                          type="number"
                          defaultValue={0}
                          disabled={!editable}
                          value={item?.quantity ?? 0}
                          name="quantity"
                          onChange={(e) => handleChangeQty(e, item)}
                          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}

                    />
                    <span className="input-group-text text-sm-center">{ product?.units?.name ?? ""}</span>
                  </div>
                </td>
              )}
              {!hideCols.includes('vat') && (
                <td>
                  <div className="input-group input-group-sm mb-3 ">
                    {product?.vat ?? 0}%
                  </div>
                </td>
              )}
              {!hideCols.includes('warehouse') && (
                <td>
                  { item.warehouse?.quantity ?? 0 }
                </td>
              )}
              {!hideCols.includes('note') && (
                <td>
                  { item.note ?? '' }
                </td>
              )}
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  </>
}
export default ProductTable